import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoodsreceivedService {


  constructor(private http: HttpClient) { }
  url = environment.serverAPI5 + '/' + 'api/goodsreceived';

  url1 = environment.serverAPI1 + "/api";

  searchGoodsreceived(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getGoodsreceived(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getGoodsreceivedById(goodsResivedId: number): Observable<Object> {
    return this.http.get(`${this.url}/${goodsResivedId}`);
  }


  createGoodsreceived(goodsreceived: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, goodsreceived);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }

  getAllGoodsreceivedDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  deleteByGoodsreceivedId(goodsResivedId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${goodsResivedId}`);
  }
  downloadGoodsreceivedTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }
  downloadGoodsreceivedReport(Page: number, size: number, sort, selectionTransfers): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionTransfers, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }
}
